module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "Reset-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Reset-content-tab"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-phone"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passWord),
      expression: "passWord"
    }],
    staticClass: "phone",
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.passWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-code"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CpassWord),
      expression: "CpassWord"
    }],
    staticClass: "phone",
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.CpassWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CpassWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-btn"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "重置密码"
    },
    on: {
      "click": _vm.submit
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Reset-content-title"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("安全验证")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("重置密码")]), _vm._v(" "), _c('li', [_vm._v("修改成功")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "One"
  }), _vm._v(" "), _c('span', {
    staticClass: "Two"
  }), _vm._v(" "), _c('span', {
    staticClass: "Three"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a284e39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Confirm.vue
// module id = 760
// module chunks = 1